import moment from 'moment'

export default function formDate(date) {
  const dateTime = moment(date).format('YYYY/MM/DD')
  return dateTime
}



// WEBPACK FOOTER //
// ./src/utils/form-date.js